import "./MastermindBoard.css";
import { useMemo, useState, useEffect, useContext } from "react";
import Pegs from "./Pegs";
import DecodeRow from "./DecodeRow";
import { ThemeContext } from "../App";
import { RefreshIcon } from "./Icons";



const MastermindBoard = (props) => {
  const {
    CODES,
    ATTEMPTS,
    PEGSINROW,
    SUCCESSCODE,
    activatedRow,
    setActivatedRow,
    decodeRowsHints,
    setDecodeRowsHints,
    rowsAnswers,
    setRowsAnswers,
    restartGame,
    decodeRows,
    setDecodeRows,
    setOutOfChances,
    setWinnerModal

  } = props;
  //theme
  const theme = useContext(ThemeContext);

  // track which peg is selected
  const [selectedPeg, setSelectedPeg] = useState("0");
  
  return (
    <div className="mastermind-board">
      <div className="decode-board">
        {decodeRows.map((_, i) => {
          return (
            <DecodeRow
              key={i}
              SUCCESSCODE={SUCCESSCODE}
              CODES={CODES}
              PEGSINROW={PEGSINROW}
              ATTEMPTS={ATTEMPTS}
              selectedPeg={selectedPeg}
              rowId={i}
              activatedRow={activatedRow}
              setActivatedRow={setActivatedRow}
              decodeRowsHints = {decodeRowsHints}
              currentRowHints = {decodeRowsHints[i]}
              setDecodeRowsHints = {setDecodeRowsHints}
              rowsAnswers = {rowsAnswers}
              currentGuess = {rowsAnswers[i]}
              setRowsAnswers = {setRowsAnswers}
              decodeRows = {decodeRows}
              decodeRow = {decodeRows[i]}
              setDecodeRows = {setDecodeRows}
              setOutOfChances = {setOutOfChances}
              setWinnerModal = {setWinnerModal}
            />
          );
        })}
      </div>
      <div className={`fixed bottom-0 right-0 drop-shadow-lg`}>
        <div onClick={restartGame} className= "mb-8">
          <RefreshIcon height="34px" width="34px" className="mx-auto" strokeColor={theme.mode === "light" ? "#4338CA" : "#fff"}/>
          <p className="text-xs">Restart</p>
        </div>
        <div className={`${theme.backgroundColor} drop-shadow-lg py-1`}>
          <Pegs
            colors={CODES}
            selectedPeg={selectedPeg}
            setSelectedPeg={setSelectedPeg}
          />
        </div>
      </div>
    </div>
  );
};

export default MastermindBoard;
